<template>
    <div class="generalframezz">
        <div class="generalcontent" :style="{width:mywidth+'px',height:myheight+'px'}">
            <div :style="{height:myTitleheight+'px',lineHeight:myTitleheight+'px'}" class="general_title">
                <div class="general_title_left">
                    <img :style="{display:tishihide==true?'inline-block':'none'}" class="timgtishi" src="./images/ty_tishi.png" />
                    <div>{{maintitle}}</div>
                </div>
                <img @click="parentHandleclick" class="timgclose" src="./images/ty_close.png" />
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name:'generalframe',
        props:{
            mywidth:{
                type:String,
                default:'420'
            },
            myheight:{
                type:String,
                default:'368'
            },
            myTitleheight:{
                type:String,
                default:'85'
            },
            maintitle:{
                type:String,
                default:''
            },
            tishihide:{
                type:Boolean,
                default:true
            }
        },
        data(){
            return{
                
            }
        },
        methods:{
            parentHandleclick() {
                this.$emit('fatherMethod');
            }
        },
        mounted(){

        },
        created(){

        },
        watch:{
            value(newVal, oldVal){
                
            }
        },
    }
</script>

<style scoped lang="less">
    .generalframezz{
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        margin: auto;
        z-index: 558;
        .generalcontent{
            // overflow-y: scroll;
            background:#fff;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            border-radius:8px;
            .general_title{
                border-bottom:1px solid rgba(236,236,236,1);
                font-size:16px;
                font-weight:400;
                color:rgba(50,50,50,1);
                display:flex;
                justify-content: space-between;
                padding:0 30px;
                align-items: center;
                .general_title_left{
                    display:flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                .timgtishi{
                    width:25px;
                    height:25px;
                    margin-right:10px;
                }
                .timgclose{
                    width:18px;
                    height:18px;
                    cursor: pointer;
                }
            }
        }
    }
</style>